export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return String(views);
}

export function normalize(text: string): string {
  return text.trim().toLowerCase();
}